module.exports = __webpack_public_path__ + "img/dk.205c1209.svg";